import { ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigation } from '@refinedev/core';

export default function ModalBackButton() {
  const { goBack } = useNavigation();

  return (
    <ActionIcon color={'black'} variant="subtle" onClick={goBack}>
      <IconArrowLeft />
    </ActionIcon>
  );
}
